module.exports = __webpack_public_path__ + "static/media/friends.bec7630e.jpg";